// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header.app-header {
    display: flex;
    height: 4rem;
    background-color: #fff;
    z-index: 1001;
    position: relative;
    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, .08);
    box-shadow: 0 2px 4px rgba(0, 0, 0, .08);
    font-size: 1.25rem;
    padding: 0 1rem;
}

header.app-header .btn {
    font-size: 1.25rem;
}

img.header-logo-blue {
    width: 124px;
}

header.app-header {
    background-image: url(/img/logo-large.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 13rem auto;
    display: flex;
}

header.app-header .nav-menu-button {
    display: none;
}

@media (max-width: 1599px) {
    header.app-header .nav-menu-button {
        margin-right: .5rem;
        display: inline-flex;
    }
}

header.app-header > * {
    margin-top: auto;
    margin-bottom: auto;
}

header.app-header ul.right-nav {
    list-style: none;
    margin: auto 0 auto auto;
    display: flex;
}

header.app-header ul.right-nav li {
    height: 2rem;
}

header.app-header ul.right-nav li .btn {
    display: inline-flex;
    height: 2rem;
}

header.app-header ul.right-nav li .btn .btn-content {
    display: inline-flex;
}

header.app-header ul.right-nav li .btn .btn-content > span {
    display: inline-flex;
}

header.app-header ul.right-nav li .btn .btn-content > span > * {
    margin-top: auto;
    margin-bottom: auto;
}

header.app-header ul.right-nav li a {
    padding: .25rem .5rem;
}

header.app-header ul.right-nav li a:last-of-type {
    padding-right: 0;
}

header.app-header ul.right-nav li + li {
    padding-left: .5rem;
}

header.app-header ul.user-nav li .btn {
    font-size: 1rem;
    padding-left: .5rem;
}

header.app-header ul.user-nav li .btn .btn-content i {
    margin-left: 0;
}

.user-nav {
    right: 1rem;
    top: 3.25rem;
}

.user-nav .user-info {
    padding: .5rem 1rem;
    border-bottom: 1px solid #ccc;
    text-align: center;
}

header .notifications-menu-wrapper {
    position: relative;
    text-align: right;
    overflow-x: visible;
    width: 3rem;
}

header .notifications-menu-wrapper li {

}

header .notifications-dropdown .notification-list-read-button {
    margin-top: auto;
    margin-bottom: auto;
    padding-right: 1rem;
    padding-left: 1rem;
}

header .notifications-dropdown .notification-list-read-button a {
    height: unset;
    display: unset;
    min-width: unset;
    padding: unset;
    color: unset;
    font-size: unset;
}

header .notifications-button {
    position: relative;
}

header .notifications-button.active i {
    color: darkred;
    animation: blink-live 3s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

@keyframes blink-live{
    0% { opacity: 1.0; }
    50% { opacity: 0.25; }
    100% { opacity: 1.0; }
}


header .notifications-button span.badge {
    color: #333;
    top: 0;
    right: -.5rem;
    font-size: 1rem;
    font-weight: bold;
}

header .notifications-dropdown {
    right: 0;
    top: 2rem;
    min-width: 25rem;
    position: absolute;
}

header .notifications-dropdown .notifications-list {
    width: 100%;
    max-height: 25rem;
    overflow-y: auto;
    overflow-x: hidden;
    text-align: left;
    position: relative;
    padding: 0;
    margin-bottom: 2rem;
}

header.app-header .notifications-dropdown .notifications-list li {
    padding: .5rem 1rem;
    height: auto;
}

header .notifications-dropdown .notifications-list li .loading-placeholder.title {
    width: 33%;
    height: 1rem;
}

header .notifications-dropdown .notifications-list li .loading-placeholder.message {
    height: 2rem;
    width: 100%;
}

header .notifications-dropdown .notifications-list li + li,
header .notifications-dropdown .notifications-list li:first-of-type {
    margin-top: .5rem;
}

header .notifications-dropdown .notifications-list li:last-of-type {
    margin-bottom: .5rem;
}

header .notifications-dropdown .notifications-list li.unread {
    padding-right: 0;
}

header .notifications-dropdown .notifications-list li.unread .title {
    font-weight: bold;
}

header .notifications-dropdown .notifications-list li .title {
    font-size: .9rem;
}

header .notifications-dropdown .notifications-list li .title .red-badge {
    margin-left: .25rem;
    border-radius: 2px;
    background-color: red;
    color: #FFF;
    font-size: .75rem;
    padding: .1rem .25rem;
}

header .notifications-dropdown .notifications-list li .message {
    font-size: .8rem;
}

header .notifications-dropdown .dropdown-header {
    border-bottom: 1px solid #ccc;
    height: 2.5rem;
    display: flex;
    padding-left: 1rem;
    padding-right: 1rem;
}

header .notifications-dropdown .dropdown-footer {
    width: 100%;
    text-align: center;
    font-size: 75%;
    font-style: italic;
    color: #999;
    border-top: 1px solid #cdcdcd;
    position: absolute;
    left: 0;
    bottom: 0;
    height: 2rem;
    line-height: 2rem;
}

header .notifications-dropdown .dropdown-header .btn {
    font-size: .75rem;
    margin-left: auto;
    margin-top: center;
    margin-bottom: center;
}

.login-page header > img {
    margin: auto 0 auto 1rem;
    width: 62px;
    height: 9px;
}

.login-page header > span {
    margin: auto 0 auto 1rem;
}

.login-page header > a {
    margin: auto 1rem auto auto;
}
`, "",{"version":3,"sources":["webpack://./src/styles/header.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,gDAAgD;IAChD,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0CAA0C;IAC1C,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,mBAAmB;QACnB,oBAAoB;IACxB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;;AAEA;;AAEA;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,8DAA8D;AAClE;;AAEA;IACI,KAAK,YAAY,EAAE;IACnB,MAAM,aAAa,EAAE;IACrB,OAAO,YAAY,EAAE;AACzB;;;AAGA;IACI,WAAW;IACX,MAAM;IACN,aAAa;IACb,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":["header.app-header {\r\n    display: flex;\r\n    height: 4rem;\r\n    background-color: #fff;\r\n    z-index: 1001;\r\n    position: relative;\r\n    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, .08);\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, .08);\r\n    font-size: 1.25rem;\r\n    padding: 0 1rem;\r\n}\r\n\r\nheader.app-header .btn {\r\n    font-size: 1.25rem;\r\n}\r\n\r\nimg.header-logo-blue {\r\n    width: 124px;\r\n}\r\n\r\nheader.app-header {\r\n    background-image: url(/img/logo-large.png);\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    background-size: 13rem auto;\r\n    display: flex;\r\n}\r\n\r\nheader.app-header .nav-menu-button {\r\n    display: none;\r\n}\r\n\r\n@media (max-width: 1599px) {\r\n    header.app-header .nav-menu-button {\r\n        margin-right: .5rem;\r\n        display: inline-flex;\r\n    }\r\n}\r\n\r\nheader.app-header > * {\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n}\r\n\r\nheader.app-header ul.right-nav {\r\n    list-style: none;\r\n    margin: auto 0 auto auto;\r\n    display: flex;\r\n}\r\n\r\nheader.app-header ul.right-nav li {\r\n    height: 2rem;\r\n}\r\n\r\nheader.app-header ul.right-nav li .btn {\r\n    display: inline-flex;\r\n    height: 2rem;\r\n}\r\n\r\nheader.app-header ul.right-nav li .btn .btn-content {\r\n    display: inline-flex;\r\n}\r\n\r\nheader.app-header ul.right-nav li .btn .btn-content > span {\r\n    display: inline-flex;\r\n}\r\n\r\nheader.app-header ul.right-nav li .btn .btn-content > span > * {\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n}\r\n\r\nheader.app-header ul.right-nav li a {\r\n    padding: .25rem .5rem;\r\n}\r\n\r\nheader.app-header ul.right-nav li a:last-of-type {\r\n    padding-right: 0;\r\n}\r\n\r\nheader.app-header ul.right-nav li + li {\r\n    padding-left: .5rem;\r\n}\r\n\r\nheader.app-header ul.user-nav li .btn {\r\n    font-size: 1rem;\r\n    padding-left: .5rem;\r\n}\r\n\r\nheader.app-header ul.user-nav li .btn .btn-content i {\r\n    margin-left: 0;\r\n}\r\n\r\n.user-nav {\r\n    right: 1rem;\r\n    top: 3.25rem;\r\n}\r\n\r\n.user-nav .user-info {\r\n    padding: .5rem 1rem;\r\n    border-bottom: 1px solid #ccc;\r\n    text-align: center;\r\n}\r\n\r\nheader .notifications-menu-wrapper {\r\n    position: relative;\r\n    text-align: right;\r\n    overflow-x: visible;\r\n    width: 3rem;\r\n}\r\n\r\nheader .notifications-menu-wrapper li {\r\n\r\n}\r\n\r\nheader .notifications-dropdown .notification-list-read-button {\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n    padding-right: 1rem;\r\n    padding-left: 1rem;\r\n}\r\n\r\nheader .notifications-dropdown .notification-list-read-button a {\r\n    height: unset;\r\n    display: unset;\r\n    min-width: unset;\r\n    padding: unset;\r\n    color: unset;\r\n    font-size: unset;\r\n}\r\n\r\nheader .notifications-button {\r\n    position: relative;\r\n}\r\n\r\nheader .notifications-button.active i {\r\n    color: darkred;\r\n    animation: blink-live 3s cubic-bezier(0, 0.2, 0.8, 1) infinite;\r\n}\r\n\r\n@keyframes blink-live{\r\n    0% { opacity: 1.0; }\r\n    50% { opacity: 0.25; }\r\n    100% { opacity: 1.0; }\r\n}\r\n\r\n\r\nheader .notifications-button span.badge {\r\n    color: #333;\r\n    top: 0;\r\n    right: -.5rem;\r\n    font-size: 1rem;\r\n    font-weight: bold;\r\n}\r\n\r\nheader .notifications-dropdown {\r\n    right: 0;\r\n    top: 2rem;\r\n    min-width: 25rem;\r\n    position: absolute;\r\n}\r\n\r\nheader .notifications-dropdown .notifications-list {\r\n    width: 100%;\r\n    max-height: 25rem;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    text-align: left;\r\n    position: relative;\r\n    padding: 0;\r\n    margin-bottom: 2rem;\r\n}\r\n\r\nheader.app-header .notifications-dropdown .notifications-list li {\r\n    padding: .5rem 1rem;\r\n    height: auto;\r\n}\r\n\r\nheader .notifications-dropdown .notifications-list li .loading-placeholder.title {\r\n    width: 33%;\r\n    height: 1rem;\r\n}\r\n\r\nheader .notifications-dropdown .notifications-list li .loading-placeholder.message {\r\n    height: 2rem;\r\n    width: 100%;\r\n}\r\n\r\nheader .notifications-dropdown .notifications-list li + li,\r\nheader .notifications-dropdown .notifications-list li:first-of-type {\r\n    margin-top: .5rem;\r\n}\r\n\r\nheader .notifications-dropdown .notifications-list li:last-of-type {\r\n    margin-bottom: .5rem;\r\n}\r\n\r\nheader .notifications-dropdown .notifications-list li.unread {\r\n    padding-right: 0;\r\n}\r\n\r\nheader .notifications-dropdown .notifications-list li.unread .title {\r\n    font-weight: bold;\r\n}\r\n\r\nheader .notifications-dropdown .notifications-list li .title {\r\n    font-size: .9rem;\r\n}\r\n\r\nheader .notifications-dropdown .notifications-list li .title .red-badge {\r\n    margin-left: .25rem;\r\n    border-radius: 2px;\r\n    background-color: red;\r\n    color: #FFF;\r\n    font-size: .75rem;\r\n    padding: .1rem .25rem;\r\n}\r\n\r\nheader .notifications-dropdown .notifications-list li .message {\r\n    font-size: .8rem;\r\n}\r\n\r\nheader .notifications-dropdown .dropdown-header {\r\n    border-bottom: 1px solid #ccc;\r\n    height: 2.5rem;\r\n    display: flex;\r\n    padding-left: 1rem;\r\n    padding-right: 1rem;\r\n}\r\n\r\nheader .notifications-dropdown .dropdown-footer {\r\n    width: 100%;\r\n    text-align: center;\r\n    font-size: 75%;\r\n    font-style: italic;\r\n    color: #999;\r\n    border-top: 1px solid #cdcdcd;\r\n    position: absolute;\r\n    left: 0;\r\n    bottom: 0;\r\n    height: 2rem;\r\n    line-height: 2rem;\r\n}\r\n\r\nheader .notifications-dropdown .dropdown-header .btn {\r\n    font-size: .75rem;\r\n    margin-left: auto;\r\n    margin-top: center;\r\n    margin-bottom: center;\r\n}\r\n\r\n.login-page header > img {\r\n    margin: auto 0 auto 1rem;\r\n    width: 62px;\r\n    height: 9px;\r\n}\r\n\r\n.login-page header > span {\r\n    margin: auto 0 auto 1rem;\r\n}\r\n\r\n.login-page header > a {\r\n    margin: auto 1rem auto auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
